import { defineComponent as n, createBlock as o, openBlock as p, unref as c, mergeProps as l, withCtx as i, createElementVNode as e } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconCurrencySwedishKrone",
  __name: "IconCurrencySwedishKrone",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (d, a) => (p(), o(c(s), l(t, { "view-box": "0 0 20 20" }), {
      default: i(() => [...a[0] || (a[0] = [
        e("g", { "clip-path": "url(#hekp3fa)" }, [
          e("path", { d: "M2.25 1.5a.75.75 0 0 0-1.5 0v17a.75.75 0 0 0 1.5 0v-4.676l.782-.736 6.46 5.963a.75.75 0 1 0 1.017-1.102l-6.382-5.891 6.387-6.012a.75.75 0 1 0-1.028-1.092l-7.236 6.81V1.5M13 5.25A.75.75 0 0 1 13.75 6v.2a9.496 9.496 0 0 1 .111-.059c.46-.242.998-.478 1.586-.57a3.05 3.05 0 0 1 1.903.3c.639.329 1.227.892 1.774 1.713a.75.75 0 1 1-1.248.832c-.453-.679-.865-1.032-1.21-1.21a1.552 1.552 0 0 0-.988-.152c-.35.054-.718.203-1.117.414a14.159 14.159 0 0 0-.595.337L13.75 7.933V18.5a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 13 5.25" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "hekp3fa" }, [
            e("path", { d: "M0 0h20v20H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
